<template>
  <div>
    <div class="main-content card p-1" v-if="loader === 100">
      <div class="row">
        <div class="col-md-12">
          <h6>Dados gravados em {{ painel.created_at_f }}</h6>
          <h6 v-show="painel.updated_at">Última edição em {{ painel.updated_at_f }}</h6>
        </div>
        <div class="col-md-12">
          <label>Unidade</label>
          <input type="text" class="form-control" v-model="painel.unidade.nome" disabled />
        </div>
        <div class="col-md-12">
          <label>Nome</label>
          <input type="text" class="form-control" v-model="painel.nome" disabled />
        </div>
        <div class="col-md-3">
          <label>Background</label>
          <input type="color" class="form-control" v-model="painel.background" disabled />
        </div>
        <div class="col-md-3">
          <label>Cor do card</label>
          <input type="color" class="form-control" v-model="painel.cor_card" disabled />
        </div>
        <div class="col-md-3">
          <label>Cor primaria</label>
          <input type="color" class="form-control" v-model="painel.cor_primaria" disabled />
        </div>
        <div class="col-md-3">
          <label>Cor secundaria</label>
          <input type="color" class="form-control" v-model="painel.cor_secundaria" disabled />
        </div>
        <div class="col-md-4">
          <label>Alerta</label>
          <select class="form-control" v-model="painel.alerta" disabled>
            <option :value="'S'" :key="'S'">Chamada por voz</option>
            <option :value="'alerta_padrao.mp4'" :key="'alerta_padrao.mp4'">Alerta padrão</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Arredondamento ({{ painel.arredondamento }}px)</label>
          <input type="range" class="form-control" v-model="painel.arredondamento" disabled />
        </div>
        <div class="col-md-4">
          <button class="btn btn-primary w-100 mt-1" :disabled="(painel.relogio ? false : true)">Relógio</button>
        </div>
        <div class="col-md-4">
          <button class="btn btn-primary w-100 mt-1" :disabled="(painel.ibge ? false : true)">IBGE</button>
        </div>
        <div class="col-md-4">
          <button class="btn btn-primary w-100 mt-1" :disabled="(painel.previsao ? false : true)">Previsão</button>
        </div>
        <div class="col-md-4">
          <button class="btn btn-primary w-100 mt-1" :disabled="(painel.mostra_pessoa ? false : true)">Mostra pessoa</button>
        </div>        
        <div class="col-md-12">
          <label>Mensagem</label>
          <textarea class="form-control" v-model="painel.mensagem" disabled></textarea>
        </div>
        <div class="col-md-4">
          <label>ID central</label>
          <input type="text" class="form-control" v-model="painel.id" disabled />
        </div>
        <div class="col-md-4">
          <label>ID original</label>
          <input type="text" class="form-control" v-model="painel.original_id" disabled />
        </div>
        <div class="col-md-4">
          <label>Status</label>
          <input type="text" class="form-control" v-model="painel.ativo" disabled />
        </div>
        <div class="col-md-6 text-left d-flex align-items-end">
          <h5>Última sincronização realizada em {{ painel.sincronizacao_f }}</h5>
        </div>
        <div class="col-md-6 text-right">
          <hr />
          <router-link to="/paineis" class="btn btn-back">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>
        </div>
      </div>
    </div>
    <div class="row justify-content-center mt-3" v-else>
      <div class="col-10 text-center">
        <div class="progress">
          <div
            class="progress-bar bg-primary"
            role="progressbar"
            :style="'width: ' + loader + '%;'"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <b style="font-size: 14pt">Carregando</b><br />
        <b style="font-size: 16pt; line-height: 12pt">{{ loader }}%</b>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      loader: 0,
      painel: {},
    };
  },
  computed: {},
  methods: {
    getPainel: function (id) {
      const self = this;
      const api = self.$store.state.api + "paineis/" + id + '?with[]=unidade';

      axios
        .get(api)
        .then((response) => {
          if(response.data.data[0])
          {
            self.painel = response.data.data[0];
            
            self.painel.ativo = self.painel.ativo ? "Ativo" : "Inativo";
            
            self.setLoader(50);
          }else{
            this.$router.push("/no-item");
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    setLoader: function (qtd) {
      const self = this;

      let load = 0;
      let interval = setInterval(function () {
        self.loader++;
        load++;

        if (load == qtd) {
          clearInterval(interval);
        }
      }, 15);
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.setLoader(50);

    if (id) {
      self.getPainel(id);
    } else {
      self.setLoader(50);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>